import axios from 'axios';

const state = {
    cmsPage: {},
};

const mutations = {
    SET_CMS_PAGE(state, cmsPage) {
        state.cmsPage = cmsPage;
    },
};

const actions = {
    fetchCMSPage: async ({ commit }, { urlSlug }) => {
        if (
            ['/', '/start', '/startseite', '/startseite.html'].includes(urlSlug)
        ) {
            urlSlug = '/start';
        } else if (
            [
                '/en',
                '/en/start',
                '/en/startseite',
                '/en/startseite.html',
            ].includes(urlSlug)
        ) {
            urlSlug = 'en/start';
        }
        await axios
            .get(`${urlSlug}`)
            .then((response) => {
                let page = response.data;
                return commit('SET_CMS_PAGE', page);
            })
            .catch((error) => {
                commit('SET_HTTP_STATUS_CODE', error.response.status);
                commit('SET_CMS_PAGE', {});
                throw Error(error);
            });
    },
};

const getters = {
    v1cmsPage: (state) => (name) => {
        const storedPages = [...state.cmsPage];
        let result = {};

        storedPages.forEach((cmsPage) => {
            if (cmsPage.name === name) {
                result = cmsPage;
            }
        });

        return result;
    },

    cmsPage: (state) => {
        return state.cmsPage;
    },
};

export default { state, mutations, actions, getters };
